import { styled } from "@mui/material/styles";
import { Box, Stack } from "@mui/material";
import { HubCardStack } from "../../components";

export const StyledLabelBox = styled(Box, {
  shouldForwardProp: (prop) => !["color"].includes(prop),
})(({ color, theme }) => ({
  height: "8px",
  width: "8px",
  borderRadius: "6px",
  backgroundColor:
    theme.palette.hubColors[color] || theme.palette.hubColors.greyLight,
}));

export const StyledHubCardStack = styled(HubCardStack)({
  flexDirection: "row",
  height: "fit-content",
  gap: "10px",
  flexGrow: 0,
  padding: "7px 10px",
  alignItems: "center",
  ".MuiChip-root": {
    fontSize: "10px",
    fontWeight: 600,
    padding: "3px 2px",
  },
});

export const StyledContainer = styled(Stack)(({ theme }) => ({
  height: "100%",
  padding: "15px 15px 0px 15px",
  overflowY: "auto",
  ".HubDroppablesContainer-root": {
    overflow: "visible",
    width: "fit-content",
    backgroundColor: "transparent",
    padding: 0,
  },
  ".HubDroppable-stack": {
    height: "100%",
    width: "260px",
    minWidth: "260px",
    maxWidth: "260px",
    padding: "5px",
    boxSizing: "border-box",
    backgroundColor: theme.palette.hubColors.greyLightest,
    border: "1px solid",
    borderColor: theme.palette.hubColors.greyLight,
    borderRadius: "15px",
  },
  ".HubDroppable-root": {
    height: "100%",
    gap: "3px",
  },
}));

export const StyledCard = styled(Stack)(({ theme }) => ({
  width: "250px",
  maxWidth: "250px",
  padding: "14px",
  borderRadius: 10,
  backgroundColor: theme.palette.hubColors.white,
  border: `1px solid ${theme.palette.hubColors.greyLight}`,
  cursor: "grab",
  gap: "10px",
  transition: "box-shadow 0.15s ease",
  "&:hover": {
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
  },
}));
